export default [
	{
		name: 'root',
		label: 'Wrapper',
		selector: '&'
	},
	{
		name: 'text',
		label: 'Text',
		selector: '& .text'
	},
	{
		name: 'stockNumber',
		label: 'Stock Number',
		selector: '& .stock-number'
	},
	{
		name: 'bar',
		label: 'Bar',
		selector: '& .bar'
	}
]